import { WhatsAppPrimaryContent } from 'modules/campaigns/editor/types';
import { TemplateType } from 'constants/templateTypes';
import { useTemplateContext } from '../../../context';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { LightText } from '../Sections.styled';

export const WhatsAppSendingInformationSection = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent, templateType } = templateAndContent;

  const isBusinessInitiated = templateType === TemplateType.BusinessInitiated;
  const sender = (primaryContent as WhatsAppPrimaryContent)?.whatsAppSender?.displayName;
  const whatsAppCategory = (primaryContent as WhatsAppPrimaryContent)?.whatsAppCategory;

  return (
    <>
      {isBusinessInitiated && (
        <CampaignFormField labelText="WhatsApp category">
          <ReadOnlyField name="whatsapp-category">
            {whatsAppCategory || <LightText>Not set</LightText>}
          </ReadOnlyField>
        </CampaignFormField>
      )}

      <CampaignFormField labelText="Sender">
        <ReadOnlyField name="sender">{sender || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
